import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Text, Title, message } from 'ui';
import { ForgotPasswordForm } from '../components';
import { useRequestResetQuery } from '../queries';

type P = {
  email?: string;
  onNavigateToPrimaryLogin: () => Promise<void>;
  onResetSuccess: () => void;
};

const ForgotPassword = ({ email, onNavigateToPrimaryLogin, onResetSuccess }: P) => {
  const { t } = useTranslation();
  const {
    data: resetPasswordData,
    error: resetPasswordError,
    isPending: isLoadingResetPasswordRequest,
    mutate: resetPassword,
  } = useRequestResetQuery();
  const [isResetSuccess, setIsResetSuccess] = useState(false);

  const onSubmit = ({ email: resetEmail }: { email: string }) => {
    resetPassword({ domain: window.location.hostname, email: resetEmail });
  };

  useEffect(() => {
    if (resetPasswordData) {
      // eslint-disable-next-line react-hooks/set-state-in-effect -- TODO: fix later
      setIsResetSuccess(true);
    }
  }, [resetPasswordData]);

  useEffect(() => {
    if (resetPasswordError) {
      if (resetPasswordError.response && resetPasswordError.response.status >= 500) {
        message.error(t('Something went wrong. Please, try again later.'));
      } else {
        // eslint-disable-next-line react-hooks/set-state-in-effect -- TODO: fix later
        setIsResetSuccess(true);
      }
    }
  }, [resetPasswordError, t]);

  return (
    <>
      <Title level={1} marginBottom>
        {t('Forgot password')}
      </Title>
      {isResetSuccess ? (
        <>
          <Text className="onboarding-forgot-password__reset-request-message">{t('resetRequestSuccess')}</Text>
          <Button
            block
            onClick={() => {
              onResetSuccess();
            }}
            size="large"
          >
            Back to Log in
          </Button>
        </>
      ) : (
        <div className="onboarding-forgot-password__form-wraper">
          <ForgotPasswordForm
            email={email}
            loading={isLoadingResetPasswordRequest}
            onNavigateToPrimaryLogin={async () => {
              await onNavigateToPrimaryLogin();
            }}
            onSubmit={onSubmit}
          />
        </div>
      )}
    </>
  );
};

export default ForgotPassword;
